import { createReducer } from '@reduxjs/toolkit';
import { IPaymentMethod } from '@wix/cashier-core/dist/src/services/PaymentMethod/types';
import { fetchRecurringPaymentMethods } from '../../actions/fetchRecurringPaymentMethods';

export type IPaymentMethodsState = {
  recurringMethods: IPaymentMethod[];
};

const initialState: IPaymentMethodsState = {
  recurringMethods: [],
};

export const paymentMethodsReducer = createReducer(initialState, (builder) =>
  builder.addCase(fetchRecurringPaymentMethods.fulfilled, (state, action) => {
    state.recurringMethods = action.payload;
  }),
);
